import React, {useEffect} from "react";
import {connect} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";



// components
import PaxForm from "./_form";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import PaxFilters from "./_filters";

// labels
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {
    LB_ACTIONS, LB_CODE, LB_NAME, LB_NATIONALITY,
    LB_ORDER, LIST, NO_DATA_FOUND
} from "../../../components/i18n/i18n";

// actions
import {genericActions} from "../../../redux/actions/generics/GenericActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setMapConfig, setViewMode} from "../../../redux/actions/generalActions/mainActions";

// services
import {paxService} from "../../../jwt/_services/clasificator/paxService";





const PaxList = (props) => {
    const { app } = props.mainProps;
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps

    const fbDataBase = {id: app?.fbDataBase?.id}

    useEffect( () => {
        if(filter || !app?.id)
            return

        props.setFilter({
            fbDataBase,
            item: { name: null }
        })
    }, [app]);

    useEffect(() => {
        if(!filter)
            return

        genericActions.search(paxService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);

    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        ModalFormContainer(PaxForm, {data, Form:PaxForm})
    }


    const confirmDelete = (data) => ConfirmDelete({
        remove : genericActions.remove ,
        fbDataBaseId: app?.fbDataBase?.id,
        data : data,
        service: paxService,
    } );


    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            text: `UID`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '200px'}
        }, {
            dataField: 'code',
            text: `${LB_CODE}`,
            headerStyle: {width: '80px'}
        }, {
            dataField: 'name',
            text: `${LB_NAME}`,
        }, {
            dataField: 'nationality',
            text: `${LB_NATIONALITY}`,
        }, {
            dataField: 'showOrder',
            text: `${LB_ORDER}`,
            headerStyle: {width: '30px'},
            headerAlign: 'center',
            align: 'center',
        }, {
            dataField: 'status',
            text: "Activo",
            headerStyle: {width: '30px'},
            headerAlign: 'center',
            align: 'center',
            formatter: (cell) => <ActiveFormatter active={cell}/>
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '200px'},
            formatter: (cell, row) => <>
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
                <TranslateButton item={row} service={ paxService } />
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </>
        }];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2" />{LIST}
        </CardTitle>

        <PaxFilters />

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setForm,
    setItem,
    setFilter,
    setViewMode,
    setMapConfig,
    setTableParams,
})
export default connect(mapStateToProps, mapActionsToProps)(PaxList)